/** @format */

import {
	Chain,
	PromotionDetailsMapV1,
	PromotionDetailsMapV2
} from '@shared/data-access/interfaces';
import { Component, Input, OnInit } from '@angular/core';

import { DiscountEligibilityService } from '@shared/data-access/product';
import { Store } from '@ngrx/store';
import { selectResolvedSku } from '@pdp/data-access/state';
import { take } from 'rxjs';

@Component({
	selector: 'pdp-promotion',
	templateUrl: './promotion.component.html',
	styleUrl: './promotion.component.scss',
	standalone: false
})
export class PromotionComponent implements OnInit {
	@Input() promotions: PromotionDetailsMapV1 | PromotionDetailsMapV2;

	@Input() addFlexBox = false;

	public chainIdentifierAbbr = this.chain.chainIdentifierAbbr;

	public heading = 'Promotion Details';

	public isSidePanelToggled = false;

	public displayPromotion;

	public ecodePromotion;

	constructor(
		public chain: Chain,
		private store: Store,
		private discountEligibilityService: DiscountEligibilityService
	) {}

	ngOnInit() {
		this.displayPromotion = this.promotions['ecode'] ? this.promotions['ecode'] : undefined;

		this.ecodePromotion = this.promotions;

		this.store.select(selectResolvedSku).subscribe((resolvedSku) => {
			this.getSkuPromotionData(resolvedSku?.parentPartNumber, resolvedSku?.partNumber);
		});
	}

	getSkuPromotionData(ecode: string, skuId: string) {
		if (!skuId) {
			this.promotions = this.ecodePromotion;
			return;
		}

		const promoMessageSubscription = this.discountEligibilityService.getPromoMessage$(
			ecode,
			skuId
		);

		if (!promoMessageSubscription) {
			this.promotions = this.ecodePromotion;
			return;
		}

		promoMessageSubscription.pipe(take(1)).subscribe((promoMessage) => {
			const message = promoMessage?.itemPromoMessage
				? promoMessage.itemPromoMessage
				: promoMessage?.shippingPromoMessage;
			if (message) {
				this.promotions = {
					ProductLevelPromotion: {
						longDesc: '',
						pdpDesc: message.pdpItemMessage
							? message.pdpItemMessage
							: message.pdpShippingMessage,
						promoDesc: message.pdpItemMessage
							? message.pdpItemMessage
							: message.pdpShippingMessage,
						promotionId: message.discountId,
						adminName: '',
						catentryId: '',
						groupName: '',
						priority: 0,
						promoFreeGift: ''
					}
				};
			} else {
				this.promotions = this.ecodePromotion;
			}
		});
	}

	panelOpened(event) {
		if (
			!event.opened ||
			!this.isPromotionDetailsMapV1(this.promotions) ||
			this.promotions.ProductLevelPromotion.longDesc
		) {
			return;
		}

		if (this.promotions.ProductLevelPromotion?.promotionId) {
			this.discountEligibilityService
				.getPromoDescription$(
					undefined,
					undefined,
					this.promotions.ProductLevelPromotion?.promotionId
				)
				.pipe(take(1))
				.subscribe((promoDescription) => {
					this.promotions = {
						ProductLevelPromotion: {
							...this.promotions.ProductLevelPromotion,
							longDesc: promoDescription
						}
					} as PromotionDetailsMapV1;
				});
		} else {
			this.promotions = {
				ProductLevelPromotion: {
					...this.promotions.ProductLevelPromotion,
					longDesc:
						"<p class='hmf-m-xs hmf-subheader-s'>Select options for more details<p>"
				}
			};
		}
	}

	private isPromotionDetailsMapV1(promoDetails: unknown): promoDetails is PromotionDetailsMapV1 {
		return Boolean(
			(promoDetails as PromotionDetailsMapV1)?.ProductLevelPromotion !== undefined
		);
	}

	trackByFn(index: number, item: PromotionDetailsMapV1): string {
		return index.toString() + item?.ProductLevelPromotion?.promotionId;
	}
}
